// TODO: theming properly
const teal35 = '#aad8d6';
const teal5 = '#f4fafa';
const black89H = '#333333';
const teal = '#008b87';

export { teal, teal5, teal35, black89H };
